(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wf2-magic-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wf2-hero-video')) {
  customElements.define('wf2-hero-video', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 749px)');
      this.screen = this.querySelector('.wf2-hero-video__screen');
      this.button = this.querySelector('button');
      this.visible = true;
      this.userPaused = false;
      this.motion.addEventListener('change', () => this.update(), options);
      this.mobile.addEventListener('change', () => this.update(), options);
      document.addEventListener('visibilitychange', () => this.update(), options);
      this.button.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.update();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.update();
      });
      this.observer.observe(this);
      this.update();
    }
    clearVideo() {
      this.removeAttribute('data-playing');
      this.button.hidden = true;
      if (this.video) {
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
        this.video.load();
        this.video.remove();
        this.video = null;
      }
      this.variant = null;
    }
    update() {
      if (this.motion.matches || (this.mobile.matches && this.dataset.mobileEnabled !== 'true')) {
        this.clearVideo();
        return;
      }
      const variant = this.mobile.matches ? 'mobile' : 'desktop';
      if (variant !== this.variant) {
        this.clearVideo();
        const template = this.querySelector(`template[data-video-variant="${variant}"]`);
        this.video = template.content.querySelector('video').cloneNode(true);
        this.variant = variant;
        this.failed = false;
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.autoplay = false;
        const video = this.video;
        video.addEventListener('playing', () => {
          if (video !== this.video) return;
          if (this.userPaused || this.motion.matches || !this.visible || document.hidden) {
            video.pause();
            return;
          }
          this.setAttribute('data-playing', '');
          this.button.hidden = false;
        }, { signal: this.controller.signal });
        video.addEventListener('error', () => {
          if (video !== this.video) return;
          this.failed = true;
          this.removeAttribute('data-playing');
          this.button.hidden = true;
        }, { signal: this.controller.signal });
        this.screen.append(video);
      }
      if (this.userPaused && !this.failed) this.button.hidden = false;
      this.button.textContent = this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel;
      if (this.userPaused || document.hidden || !this.visible) {
        this.video.pause();
      } else if (!this.failed && this.video.paused) {
        const video = this.video;
        video.autoplay = true;
        const playback = video.play();
        if (playback) playback.catch(error => {
          if (video !== this.video || error.name === 'AbortError') return;
          this.removeAttribute('data-playing');
          this.button.hidden = true;
          this.failed = true;
        });
      }
    }
    disconnectedCallback() {
      this.observer.disconnect();
      this.controller.abort();
      this.clearVideo();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
